import { Link } from 'react-router-dom';
import MangaCard from '@/components/feature/MangaCard';
import { mangaList } from '@/mocks/manga';

export default function LatestUpdate() {
  const sorted = [...mangaList].sort(
    (a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()
  );

  const weekly = sorted.slice(0, 8);

  return (
    <section className="py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">每日更新，精彩不断，追更从未如此轻松</p>
          </div>
          <div className="flex items-center gap-3">
            <button className="text-xs px-3 py-1.5 rounded-full bg-primary-500/10 text-primary-500 font-medium whitespace-nowrap cursor-pointer">
              本周更新
            </button>
            <Link
              to="/category/all"
              className="text-sm text-primary-500 hover:text-primary-400 transition-colors flex items-center gap-1 cursor-pointer whitespace-nowrap"
            >
              全部
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {weekly.map((manga) => (
            <MangaCard key={manga.id} manga={manga} />
          ))}
        </div>

        <div className="mt-8 p-6 rounded-xl bg-background-100 border border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <h3 className="text-base font-semibold text-foreground-200">还没找到喜欢的漫画？</h3>
            <p className="text-sm text-foreground-500 mt-1">浏览全部分类，发现更多精彩作品</p>
          </div>
          <Link
            to="/category/all"
            className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            探索更多
          </Link>
        </div>
      </div>
    </section>
  );
}